<template>
  <div class="luxury-app">
    <section class="luxury-hero">
      <div class="hero-backdrop">
        <div class="hero-video">
          <video autoplay muted loop playsinline>
            <source :src="getFiles('bana.mp4')" type="video/mp4">
          </video>
          <div class="video-overlay"></div>
        </div>
        
        <nav class="luxury-nav">
          <div class="nav-container">
            <div class="navbar-brand-box">
              <router-link to="/" class="logo logo-dark">
                <span class="logo-sm"><img src="@/assets/images/logo.png" height="30px" style="border-radius: 5%;"/></span>
                <span class="logo-lg"><img src="@/assets/images/logo.png" height="50px" style="border-radius: 5%;"/></span>
              </router-link>
            </div>
            
            <div class="nav-actions">
              <div class="nav-links">
                                
                <b-dropdown variant="white" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
                <template v-slot:button-content><button class="btn btn-sm nav-link"> Categories <i class="mdi mdi-chevron-down"></i></button>
                </template>
                <div class="row mega-menu">
                  <div v-for="item in categories" :key="item.id" class="col-sm-3 col-6 mb-2">
                    <h5 class="menu-column-title mt-0">{{ item.name }}</h5>
                    <div v-for="item in item.subcategories" :key="item.id" class="mb-1">
                      <router-link :to="{ path: '/category', query: { id: item.id, name:item.name }}" style="font-size: 13px;" class="menu-item"><i class="mdi mdi-arrow-right" style="font-size: 5px;"></i> {{ item.name }} </router-link>
                    </div>
                  </div>
                </div> 
              </b-dropdown>

                <router-link to="/shops" class="nav-link">Providers</router-link>
                <router-link to="/products" class="nav-link">Book Now</router-link>
              </div>
              
              <div class="nav-controls">
                <b-dropdown variant="white" class="luxury-dropdown">
                  <template v-slot:button-content>
                    <button class="control-btn"><i class="mdi mdi-translate"></i></button>
                  </template>
                  <Translator :countries="arrayOfCountries" @on-country-click="customEvent" />
                </b-dropdown>
                
                <template v-if="token">
                  <b-dropdown variant="white" class="luxury-dropdown user-dropdown">
                    <template v-slot:button-content>
                      <div class="user-avatar">
                        <img src="@/assets/images/user.png" alt="User">
                      </div>
                    </template>
                    <router-link to="/dashboard" class="dropdown-item">
                      <i class="mdi mdi-account"></i> My Account
                    </router-link>
                    <a href="/logout" class="dropdown-item">
                      <i class="mdi mdi-logout"></i> Sign Out
                    </a>
                  </b-dropdown>
                </template>
                <template v-else>
                  <router-link to="/login" class="auth-btn">
                    <span>Sign In</span>
                    <i class="mdi mdi-account-circle"></i>
                  </router-link>
                </template>
              </div>
            </div>
          </div>
        </nav>
        
        <!-- Hero Content -->
        <div class="hero-content">
          <div class="content-container">
            <h1 class="hero-title">Elevate Your Beauty Experience</h1>
            <p class="hero-subtitle">Discover premium beauty and wellness services tailored just for you</p>
            
            <div class="search-container">
              <div class="luxury-search" @click="$bvModal.show('search-modal')">
                <div class="search-icon">
                  <i class="mdi mdi-magnify"></i>
                </div>
                <input type="text" placeholder="Search for Products & Services..." readonly>
                <div class="search-hint">
                  <span>Press <kbd>/</kbd> to search</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Luxury Search Modal -->
    <b-modal id="search-modal" hide-header hide-footer modal-class="luxury-modal" centered>
      <div class="search-modal">
        <button class="modal-close" @click="$bvModal.hide('search-modal')">
          <i class="mdi mdi-close"></i>
        </button>
        
        <div class="search-header">
          <div class="search-input">
            <i class="mdi mdi-magnify"></i>
            <input 
              type="text" 
              placeholder="Search by Name or Category"
              v-model="searchQuery"
              @input="filterProduct($event)"
              autofocus
            >
          </div>
        </div>
        
        <div class="search-results">
          <div v-if="filteredProducts.length > 0" class="results-grid">
            <div 
              v-for="service in filteredProducts" 
              :key="service.id" 
              class="service-card"
              @click="goToService(service)"
            >
              <div class="service-image">
                <img :src="getProduct(service.photo)" :alt="service.name">
              </div>
              <div class="service-details">
                <h4>{{ service.name }}</h4>
                <div class="service-meta">
                  <span class="price">{{ commas(service.price) }} AED</span>
                  <h6 class="category">{{ service.category.name }}</h6>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-results">
            <div class="empty-state">
              <i class="mdi mdi-magnify"></i>
              <h4>No services found</h4>
              <p>Try searching for something else</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Featured Categories -->
    <section class="luxury-section categories-section">
      <div class="section-container">
        <div class="section-header">
          <h2>Premium Services</h2>
          <router-link to="/products" class="view-all ms-5">
            View All Services <i class="mdi mdi-arrow-right"></i>
          </router-link>
        </div>
        
        <div class="categories-grid">
          <div 
            v-for="product in limitedproducts" 
            :key="product.id" 
            class="category-card"
            :style="{ backgroundImage: `url(${getProduct(product.photo)})` }"
          >
            <div class="category-overlay"></div>
            <div class="category-content">
              <h3>{{ product.name }}</h3>
              <span class="price">{{ commas(product.price) }} AED</span>
              <h6 class="text-muted">{{ product.category.name }}</h6>
              <router-link 
                :to="{ path: '/product', query: { id: product.product_id, name: product.name }}"
                class="explore-btn"
              > Book now <i class="mdi mdi-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Top Providers -->
    <section class="luxury-section providers-section">
      <div class="section-container">
        <div class="section-header">
          <h2>Our Premium Partners</h2>
          <router-link to="/shops" class="ms-5 view-all">
            View All Providers <i class="mdi mdi-arrow-right"></i>
          </router-link>
        </div>
        
        <div class="providers-slider">
          <div v-for="provider in limitedproviders" :key="provider.id" class="provider-card">
            <div class="provider-badge"> <i class="mdi mdi-crown"></i> Premium</div>
            <div class="provider-image">
              <img :src="getVendorPhoto(provider.logo)" :alt="provider.business_name">
            </div>
            <div class="provider-details">
              <h3>{{ provider.business_name }}</h3>
              <div class="provider-location">
                <i class="mdi mdi-map-marker"></i>
                <span>{{ provider.business_address }}</span>
              </div>
              <div class="provider-rating">
                <div class="stars">
                  <i class="mdi mdi-star" v-for="n in 5" :key="n"></i>
                </div>
                <span>4.9 ({{provider.id}})</span>
              </div>
              <router-link 
                :to="{ path: '/shop', query: { id: provider.user_id }}"
                class="book-btn"
              >
                View Profile
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- App CTA -->
    <section class="luxury-section app-section">
      <div class="section-container">
        <div class="app-content">
          <div class="app-image">
            <img src="@/assets/images/mockup.png" alt="OVVURA App">
          </div>
          <div class="app-details">
            <div class="app-logo">
              <img src="@/assets/images/logo2.png" alt="OVVURA">
              <span>OVVURA MOBILE</span>
            </div>
            <h4>Book Beauty Services On The Go</h4>
            <p>Download our app to discover, book, and manage appointments from anywhere</p>
            
            <div class="app-badges">
              <button class="app-store">
                <i class="mdi mdi-apple"></i>
                <div>
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </div>
              </button>
              <button class="play-store">
                <i class="mdi mdi-google-play"></i>
                <div>
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials -->
    <section class="luxury-section testimonials-section">
      <div class="section-container">
        <div class="section-header">
          <h2>Client Experiences</h2>
          <p>What our clients say about their OVVURA experience</p>
        </div>
        
        <div class="testimonials-slider">
          <div class="testimonial-card">
            <div class="testimonial-content">
              <div class="quote-icon">
                <i class="mdi mdi-format-quote-open"></i>
              </div>
              <p>OVVURA transformed my beauty routine. The convenience of booking top professionals with just a few taps is unmatched.</p>
            </div>
            <div class="client-info">
              <img src="@/assets/images/user.png" alt="Sarah K.">
              <div>
                <h4>Sarah K.</h4>
                <span>Dubai</span>
              </div>
            </div>
          </div>
          
          <div class="testimonial-card">
            <div class="testimonial-content">
              <div class="quote-icon">
                <i class="mdi mdi-format-quote-open"></i>
              </div>
              <p>I've tried many booking platforms, but OVVURA's premium selection of providers and seamless booking stands out.</p>
            </div>
            <div class="client-info">
              <img src="@/assets/images/user.png" alt="Amina R.">
              <div>
                <h4>Amina R.</h4>
                <span>Abu Dhabi</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="p-5" style="background: #f8f9fa; text-align: center;">
      <h1>We accept a wide range of local and global payment options</h1>

      <div class="row pb-2 pt-3 justify-content-evenly">
        <div class="col-6 col-md-2 my-3">
          <img src="@/assets/images/payments/visa.png" alt="Visa" style="max-width: 100px;">
        </div>
        <div class="col-6 col-md-2 my-3">
          <img src="@/assets/images/payments/mastercard.png" alt="MasterCard" style="max-width: 100px;">
        </div>
        <div class="col-6 col-md-2 my-3">
          <img src="@/assets/images/payments/paypal.png" alt="PayPal" style="max-width: 100px;">
        </div>
        <div class="col-6 col-md-2 my-3">
          <img src="@/assets/images/payments/mada.png" alt="Amazon Pay" style="max-width: 100px;">
        </div>
        <div class="col-6 col-md-2 my-3">
          <img src="@/assets/images/payments/americanexpress.png" alt="Visa" style="max-width: 100px;">
        </div>
        <div class="col-6 col-md-2 my-3">
          <img src="@/assets/images/payments/unionpay.png" alt="MasterCard" style="max-width: 100px;">
        </div>       
      </div>
    </section>
    <Footer />
    </div>
</template>

<script>
import axios from "axios";
import { Translator } from 'vue-google-translate';
import Footer from "@/components/footer";
import { vendorMethods, vendorComputed, categorieMethods, categorieComputed, productMethods, productComputed } from "@/state/helpers";

export default {
  name: 'Ovvura Radiance',
  components: { Translator,Footer },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")) || {},
      token: localStorage.getItem("token"),
      searchQuery: '',
      arrayOfCountries: [
        { code: 'en|en', title: 'English' },
        { code: 'en|ar', title: 'Arabic' },
        { code: 'en|fr', title: 'French' },
        { code: 'en|es', title: 'Spanish' },
      ],
      featuredCategories: [],
      featuredProviders: []
    };
  },
  computed: {
    ...productComputed,
    ...vendorComputed,
    ...categorieComputed,
    filteredProducts() {
      if (!this.searchQuery) return this.products.slice(0, 6);
      return this.products.filter(product => 
        product.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        product.category.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    limitedproducts() {
      return this.products.slice(0, 4);
    },
    limitedproviders() {
      return this.vendors.slice(0, 4);
    }
  },
  methods: {
    ...productMethods,
    ...vendorMethods,
    ...categorieMethods,
    getVendorPhoto(name) {
      // if (!name) return require('@/assets/images/provider-default.jpg');
      let url = axios.defaults.baseURL;
      return (url).slice(0,-3) + "logos/" + name;
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      return (url).slice(0,-3) + "banners/" + name;
    },
    getCat(name) {
      // if (!name) return require('@/assets/images/category-default.jpg');
      let url = axios.defaults.baseURL;
      return (url).slice(0,-3) + "category/" + name;
    },
    getProduct(name) {
      // if (!name) return require('@/assets/images/service-default.jpg');
      let url = axios.defaults.baseURL;
      return (url).slice(0,-3) + "products/" + name;
    },
    commas(x) {
      return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0';
    },
    filterProduct(e) {
      this.searchQuery = e.target.value;
    },
    goToService(service) {
      this.$router.push({ path: '/product', query: { id: service.product_id }});
      this.$bvModal.hide('search-modal');
    },
    customEvent() {
      this.$router.push(this.$route.query.redirectFrom || { name: "default" });
    },
  },
  created() {
    this.fetchProducts();
    this.fetchCategories();
    this.fetchVendors();
    
    // Keyboard shortcut for search
    window.addEventListener('keydown', (e) => {
      if (e.key === '/') {
        e.preventDefault();
        this.$bvModal.show('search-modal');
      }
    });
  }
};
</script>

<style lang="scss">
/* Luxury Color Palette */
:root {
  --primary: #3A2B78FF;
  --primary-dark: #151514FF;
  --primary-light: #6E76D1FF;
  --secondary: #F5E9DC;
  --accent: #D4BFA8;
  --dark: #0B0B0BFF;
  --light: #C3E5F8FF;
  --white: #FFFFFF;
  --gray: #E5E5E5;
  --text: #333333;
  --text-light: #777777;
  --shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
  --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Base Styles */
.luxury-app {
  font-family:Arial, Helvetica, sans-serif;
  color: var(--dark);
  line-height: 1.6;
  background: var(--light);
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    font-weight: 500;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 2px;
      background: var(--primary);
    }
  }
  
  p {
    font-size: 1.2rem;
    color: var(--text-light);
    max-width: 700px;
    margin: 0 auto;
  }
  
  &.with-action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    
    h2::after {
      left: 0;
      transform: none;
    }
  }
}

.view-all {
  color: var(--primary);
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: var(--transition);
  
  &:hover {
    color: var(--primary-dark);
    transform: translateX(5px);
  }
}

/* Luxury Hero Section */
.luxury-hero {
  position: relative;
  height: 100vh;
  min-height: 800px;
  overflow: hidden;
  color: var(--white);
  
  .hero-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  
  .hero-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
    video {
      position: absolute;
      top: 50%;
      left: 50%;
      min-width: 100%;
      min-height: 100%;
      width: auto;
      height: auto;
      transform: translate(-50%, -50%);
      object-fit: cover;
    }
    
    .video-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6));
    }
  }
  
  .hero-content {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-top: 100px;
    
    .content-container {
      max-width: 900px;
      padding: 0 20px;
    }
    
    .hero-title {
      font-size: 4.0rem;
      font-weight: 500;
      margin-bottom: 20px;
      line-height: 1.2;
      color: var(--primary);
      text-shadow: 0 1px 1px rgb(255, 255, 255);
      font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    }
    
    .hero-subtitle {
      font-size: 1.5rem;
      margin-bottom: 40px;
      opacity: 0.9;
      font-weight: 300;
    }
  }
}

/* Luxury Navigation */
.luxury-nav {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  padding: 25px 0;
  transition: var(--transition);
  
  .nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
  }
  
  .brand-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--white);
    
    img {
      height: 40px;
    }
  }
  
  .nav-actions {
    display: flex;
    align-items: center;
    gap: 30px;
  }
  
  .nav-links {
    display: flex;
    align-items: center;
    gap: 25px;
    
    .nav-link {
      color: var(--white);
      font-size: 1.1rem;
      font-weight: 400;
      position: relative;
      padding: 5px 0;
      
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 1px;
        background: var(--white);
        transition: var(--transition);
      }
      
      &:hover::after {
        width: 100%;
      }
    }
  }
  
  .nav-controls {
    display: flex;
    align-items: center;
    gap: 20px;
    
    .control-btn {
      background: transparent;
      border: none;
      color: var(--white);
      font-size: 1.2rem;
      cursor: pointer;
      transition: var(--transition);
      
      &:hover {
        transform: scale(1.1);
      }
    }
    
    .auth-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--white);
      font-size: 1.1rem;
      padding: 8px 20px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 30px;
      transition: var(--transition);
      
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid var(--white);
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

/* Luxury Dropdown */
.luxury-dropdown {
  &.show .dropdown-toggle::after {
    transform: rotate(180deg);
  }
  
  .dropdown-toggle {
    &::after {
      transition: var(--transition);
    }
  }
  
  .dropdown-menu {
    border: none;
    border-radius: 8px;
    box-shadow: var(--shadow);
    padding: 15px;
    margin-top: 10px;
    
    .dropdown-item {
      padding: 10px 15px;
      font-size: 0.95rem;
      color: var(--text);
      transition: var(--transition);
      
      &:hover {
        background: var(--secondary);
        color: var(--primary-dark);
      }
    }
  }
  
  &.user-dropdown {
    .dropdown-menu {
      min-width: 200px;
    }
  }
}

/* Mega Menu */
.mega-menu {
  // width: 900px;
  padding: 30px !important;
  background: var(--white);
  
  .menu-column-title {
      font-size: 1.1rem;
      color: var(--primary);
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--gray);
  }
  
  .menu-item {
    margin-bottom: 12px;
    
    a {
      color: var(--text);
      transition: var(--transition);
      display: flex;
      align-items: center;
      gap: 8px;
      
      &:hover {
        color: var(--primary);
        transform: translateX(5px);
      }
    }
  }
}

/* Luxury Search */
.luxury-search {
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  cursor: pointer;
  
  input {
    width: 100%;
    padding: 18px 20px 18px 60px;
    border-radius: 50px;
    border: none;
    font-size: 1.1rem;
    background: rgba(255, 255, 255, 0.9);
    color: var(--text);
    transition: var(--transition);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    
    &::placeholder {
      color: var(--text-light);
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
    }
  }
  
  .search-icon {
    position: absolute;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--primary);
    font-size: 1.3rem;
  }
  
  .search-hint {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: var(--primary);
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    
    kbd {
      background: rgba(0, 0, 0, 0.2);
      padding: 2px 5px;
      border-radius: 3px;
      font-family: monospace;
    }
  }
}

/* Luxury Modal */
.luxury-modal {
  .modal-dialog {
    max-width: 900px;
  }
  
  .modal-content {
    border: none;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);
  }
}

.search-modal {
  padding: 0;
  
  .modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    font-size: 1.5rem;
    color: var(--text-light);
    z-index: 10;
    cursor: pointer;
    transition: var(--transition);
    
    &:hover {
      color: var(--primary);
      transform: rotate(90deg);
    }
  }
  
  .search-header {
    padding: 30px;
    border-bottom: 1px solid var(--gray);
    
    .search-input {
      position: relative;
      
      i {
        position: absolute;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        color: var(--primary);
        font-size: 1.3rem;
      }
      
      input {
        width: 100%;
        padding: 10px 20px 10px 50px;
        border-radius: 30px;
        border: 1px solid var(--gray);
        font-size: 1.0rem;
        transition: var(--transition);
        
        &:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px rgba(139, 111, 78, 0.2);
        }
      }
    }
  }
  
  .search-results {
    max-height: 500px;
    overflow-y: auto;
    padding: 20px;
    
    .results-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      gap: 20px;
    }
    
    .service-card {
      display: flex;
      align-items: center;
      gap: 15px;
      padding: 15px;
      border-radius: 8px;
      cursor: pointer;
      transition: var(--transition);
      
      &:hover {
        background: var(--light);
        transform: translateY(-3px);
      }
      
      .service-image {
        width: 60px;
        height: 60px;
        border-radius: 8px;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .service-details {
        flex: 1;
        
        h4 {
          font-size: 1rem;
          margin-bottom: 5px;
          font-weight: 500;
          color: var(--dark);
        }
        
        .service-meta {
          font-size: 0.9rem;
          
          .price {
            color: var(--primary);
            font-weight: 500;
            font-size: 10px;
          }
          
          .category {
            color: var(--text-light);
            font-size: 10px;
            font-style: italic;
          }
        }
      }
    }
    
    .no-results {
      padding: 50px 0;
      text-align: center;
      
      .empty-state {
        i {
          font-size: 3rem;
          color: var(--text-light);
          margin-bottom: 20px;
          opacity: 0.5;
        }
        
        h4 {
          font-size: 1.3rem;
          margin-bottom: 10px;
          color: var(--text);
        }
        
        p {
          color: var(--text-light);
        }
      }
    }
  }
}

/* Categories Section */
.categories-section {
  padding: 100px 0;
  background: var(--white);
  
  .categories-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 30px;
  }
  
  .category-card {
    position: relative;
    height: 300px;
    border-radius: 12px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: var(--shadow);
    }
    
    .category-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(197, 197, 197, 0.2));
    }
    
    .category-content {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 30px;
      color: var(--white);
      
      h3 {
        font-size: 1.5rem;
        margin-bottom: 15px;
        color: var(--white);
      }
      
      .explore-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: var(--white);
        font-weight: 500;
        transition: var(--transition);
        
        &:hover {
          color: var(--accent);
          transform: translateX(5px);
        }
      }
    }
  }
}

/* Providers Section */
.providers-section {
  padding: 100px 0;
  background: var(--light);
  
  .providers-slider {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 30px;
  }
  
  .provider-card {
    position: relative;
    background: var(--white);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: var(--shadow);
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    }
    
    .provider-badge {
      position: absolute;
      top: 15px;
      right: 15px;
      background: var(--primary);
      color: var(--white);
      padding: 5px 10px;
      border-radius: 20px;
      font-size: 0.8rem;
      display: flex;
      align-items: center;
      gap: 5px;
      z-index: 2;
    }
    
    .provider-image {
      height: 200px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: var(--transition);
      }
    }
    
    &:hover .provider-image img {
      transform: scale(1.05);
    }
    
    .provider-details {
      padding: 25px;
      
      h3 {
        font-size: 1.3rem;
        margin-bottom: 10px;
      }
      
      .provider-location {
        display: flex;
        align-items: center;
        gap: 5px;
        color: var(--text-light);
        margin-bottom: 15px;
        font-size: 0.9rem;
      }
      
      .provider-rating {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
        
        .stars {
          color: #FFC107;
        }
        
        span {
          font-size: 0.9rem;
          color: var(--text-light);
        }
      }
      
      .book-btn {
        display: inline-block;
        padding: 10px 20px;
        background: var(--primary);
        color: var(--white);
        border-radius: 30px;
        font-weight: 500;
        transition: var(--transition);
        
        &:hover {
          background: var(--primary-dark);
          transform: translateY(-3px);
        }
      }
    }
  }
}

/* App Section */
.app-section {
  padding: 5px 0;
  background: var(--white);
  
  .app-content {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .app-image {
    flex: 1;
    border-radius: 20px;
    overflow: hidden;
    // box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1);
    
    img {
      width: 60%;
      height: auto;
      display: block;
    }
  }
  
  .app-details {
    flex: 1;
    
    .app-logo {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 30px;
      
      img {
        height: 60px;
        border-radius: 10px;
      }
      
      span {
        font-size: 1.1rem;
        letter-spacing: 2px;
        color: var(--primary);
        text-transform: uppercase;
      }
    }
    
    h2 {
      font-size: 2.5rem;
      margin-bottom: 20px;
      line-height: 1.3;
    }
    
    p {
      font-size: 1.2rem;
      color: var(--text-light);
      margin-bottom: 30px;
    }
  }
  
  .app-badges {
    display: flex;
    gap: 15px;
    
    .app-store, .play-store {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px 20px;
      border-radius: 8px;
      font-size: 0.9rem;
      transition: var(--transition);
      
      i {
        font-size: 1.5rem;
      }
      
      div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        
        span {
          font-size: 0.7rem;
        }
        
        strong {
          font-size: 1rem;
          font-weight: 500;
        }
      }
    }
    
    .app-store {
      background: #000;
      color: var(--white);
      
      &:hover {
        transform: translateY(-3px);
      }
    }
    
    .play-store {
      border: 1px solid var(--gray);
      
      &:hover {
        background: var(--light);
        transform: translateY(-3px);
      }
    }
  }
}

/* Testimonials Section */
.testimonials-section {
  padding: 100px 0;
  background: var(--light);
  
  .testimonials-slider {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 30px;
    max-width: 900px;
    margin: 0 auto;
  }
  
  .testimonial-card {
    background: var(--white);
    border-radius: 12px;
    padding: 30px;
    box-shadow: var(--shadow);
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    }
    
    .testimonial-content {
      position: relative;
      margin-bottom: 30px;
      
      .quote-icon {
        position: absolute;
        top: -10px;
        left: -10px;
        font-size: 3rem;
        color: var(--primary);
        opacity: 0.2;
      }
      
      p {
        font-size: 1.1rem;
        font-style: italic;
        color: var(--text);
        line-height: 1.8;
        position: relative;
        z-index: 1;
      }
    }
    
    .client-info {
      display: flex;
      align-items: center;
      gap: 15px;
      
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid var(--primary);
      }
      
      h4 {
        font-size: 1.1rem;
        margin-bottom: 5px;
      }
      
      span {
        font-size: 0.9rem;
        color: var(--text-light);
      }
    }
  }
}

/* Luxury Footer */
.luxury-footer {
  background: var(--dark);
  color: var(--white);
  padding: 80px 0 0;
  
  .footer-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
  }
  
  .footer-main {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 80px;
    padding-bottom: 60px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .footer-brand {
    .brand-logo {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
      
      img {
        height: 40px;
      }
      
      span {
        font-size: 1.5rem;
        font-weight: 500;
      }
    }
    
    p {
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 30px;
      line-height: 1.8;
    }
  }
  
  .social-links {
    display: flex;
    gap: 15px;
    
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      color: var(--white);
      font-size: 1.2rem;
      transition: var(--transition);
      
      &:hover {
        background: var(--primary);
        transform: translateY(-3px);
      }
    }
  }
  
  .footer-links {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
  }
  
  .links-column {
    h5 {
      font-size: 1.1rem;
      font-weight: 500;
      margin-bottom: 20px;
      color: var(--white);
    }
    
    a {
      display: block;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 12px;
      transition: var(--transition);
      
      &:hover {
        color: var(--white);
        transform: translateX(5px);
      }
    }
  }
  
  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.5);
  }
  
  .legal-links {
    display: flex;
    gap: 20px;
    
    a {
      color: rgba(255, 255, 255, 0.5);
      transition: var(--transition);
      
      &:hover {
        color: var(--white);
      }
    }
  }
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .mega-menu {
    width: 700px !important;
    
    .menu-columns {
      grid-template-columns: repeat(3, 1fr) !important;
    }
  }
  
  .app-content {
    gap: 40px !important;
  }
}

@media (max-width: 992px) {
  .luxury-hero .hero-title {
    font-size: 3.5rem !important;
  }
  
  .footer-main {
    grid-template-columns: 1fr !important;
    gap: 40px !important;
  }
  
  .app-content {
    flex-direction: column !important;
  }
  
  .app-details {
    text-align: center !important;
    
    .app-badges {
      justify-content: center !important;
    }
  }
}

@media (max-width: 768px) {
  .luxury-nav .nav-container {
    flex-direction: column !important;
    gap: 20px !important;
  }
  
  .nav-actions {
    width: 100% !important;
    justify-content: space-between !important;
  }
  
  .nav-links {
    display: none !important;
  }
  
  .luxury-hero .hero-title {
    font-size: 2.5rem !important;
  }
  
  .luxury-hero .hero-subtitle {
    font-size: 1.2rem !important;
  }
  
  .categories-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
  .testimonials-slider {
    grid-template-columns: 1fr !important;
  }
  
  .footer-links {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 576px) {
  .section-container {
    padding: 0 20px !important;
  }
  
  .luxury-hero {
    min-height: 700px !important;
    
    .hero-title {
      font-size: 2rem !important;
    }
    
    .hero-subtitle {
      font-size: 1rem !important;
    }
  }
  
  .categories-grid {
    grid-template-columns: 1fr !important;
  }
  
  .footer-links {
    grid-template-columns: 1fr !important;
  }
  
  .footer-bottom {
    flex-direction: column !important;
    gap: 15px !important;
    text-align: center !important;
  }
  
  .legal-links {
    flex-wrap: wrap;
    justify-content: center !important;
  }
}
</style>